import { BasicCommand } from "~app/common/services/cqs/BasicCommand";
import { CommandType } from "~app/common/services/cqs/CommandType";
import { IPrimaryKey } from "~app/common/services/cqs/IPrimaryKey";
import { KontraktCertifikatEditDTO } from "../../models/certifiering-models";

export class UpdateKontraktCertifikatCommand extends BasicCommand<UpdateKontraktCertifikatCommand> {
    readonly kontraktGuid: string;
    readonly certifikat: KontraktCertifikatEditDTO[];

    // eslint-disable-next-line sonarjs/public-static-readonly
    static $type = "UpdateKontraktCertifikatCommand";
    // eslint-disable-next-line sonarjs/public-static-readonly
    static $groupKey = "Certifikat";

    get primaryKey(): IKontraktCertifikatPrimaryKey {
        return {
            kontraktGuid: this.kontraktGuid
        };
    }

    constructor(kontraktGuid: string, certifikat: KontraktCertifikatEditDTO[]) {
        super(UpdateKontraktCertifikatCommand.$type, UpdateKontraktCertifikatCommand.$groupKey, CommandType.Replace);
        this.kontraktGuid = kontraktGuid;
        this.certifikat = certifikat;
    }
}

export interface IKontraktCertifikatPrimaryKey extends IPrimaryKey<IKontraktCertifikatPrimaryKey>{
    kontraktGuid: string;
}
